import { useState, useEffect, useCallback, useRef } from "react";
import { debounce } from 'lodash';

import { onElementHeightChange } from "../../utils/dom";

let handleScrollPosFrom = 0;
let handleScrollPosTo = 0;
let scrollToDirection = '';

const animateScroll = () => {
	if (scrollToDirection === "down") {
		handleScrollPosFrom = handleScrollPosFrom + 75;
		if (handleScrollPosFrom < handleScrollPosTo) {
			window.scrollTo(0, handleScrollPosFrom);
			requestAnimationFrame(animateScroll)
		} else if (handleScrollPosFrom >= handleScrollPosTo) {
			window.scrollTo(0, handleScrollPosTo);
		}
	} else {
		handleScrollPosFrom = handleScrollPosFrom - 75;
		if (handleScrollPosFrom > handleScrollPosTo) {
			window.scrollTo(0, handleScrollPosFrom);
			requestAnimationFrame(animateScroll)
		} else if (handleScrollPosFrom <= handleScrollPosTo) {
			window.scrollTo(0, handleScrollPosTo);
		}
	}
}

const handleAnchorClick = (e, id) => {
	e.preventDefault();

	var element = document.getElementById(id);
	handleScrollPosFrom = window.pageYOffset;
	handleScrollPosTo = element.offsetTop - 100;

	if (handleScrollPosFrom > handleScrollPosTo) {
		scrollToDirection = "up";
	} else {
		scrollToDirection = "down";
	}

	requestAnimationFrame(animateScroll);
};

const updatePositioning = (setUiUpdated, stateValuesRef, mainNav, mainNavWrapper, subNavWrapper) => () => {
	// update scroll value
	stateValuesRef.current.scroll = window.pageYOffset;

	if (!subNavWrapper.current || !mainNav.current || !mainNavWrapper.current) {
		return;
	}

	if (stateValuesRef.current.height > 0) {
		subNavWrapper.current.style.height = `${stateValuesRef.current.height}px`;
		subNavWrapper.current.style.minHeight = `${stateValuesRef.current.height}px`;
	}

	// Main nav position based on current scroll (0 - scroll)
	let mnTop = stateValuesRef.current.top - (stateValuesRef.current.scroll);

	if (mnTop <= 0 && stateValuesRef.current.top != 0) {
		mainNavWrapper.current.style.top = `${mnTop}px`;
	} else {
		mainNavWrapper.current.style.top = 0;
	}

	// Force rerender, due to just using Refs for state.
	setUiUpdated(Math.random() * 9999);
}

const SubHeader = props => {
	const { nav, pinned, refElement } = props;

	const stateValuesRef = useRef({
		height: 58,
		top: 0,
		scroll: 0,
	});

	const [, setUiUpdated] = useState();
	const [retryTimeout, setRetryTimeout] = useState(-1);
	const subNav = useRef();
	const subNavWrapper = useRef();
	const mainNavWrapper = useRef();
	const mainNav = useRef();

	const updateValues = useCallback(() => {
		if (refElement.current) {
			stateValuesRef.current.top = refElement.current.offsetHeight;
		} else if (retryTimeout === -1) {
			// Ref not set on external component it's positioned relative to
			setTimeout(updateValues, 500);
		}
	}, [subNav, refElement]);

	// Get correct height values on resize - reuse to execute on mount too
	const windowResizeHandler = useCallback(
		debounce(() => {
			updateValues();
		}, 100),
		[updateValues]
	);

	useEffect(() => {
		mainNavWrapper.current = document.getElementsByClassName('productNav')[0];
		mainNav.current = document.querySelector('.productNav > nav');

		// Only do ONCE, as if it updates the value, the value can be 0 when scrolled down the page (due to navBuilderHolder's children no longer being a part of the layout)
		stateValuesRef.current.height = subNav.current.scrollHeight;

		updateValues();

		const updateFunc = updatePositioning(setUiUpdated, stateValuesRef, mainNav, mainNav, subNavWrapper);

		window.addEventListener("resize", windowResizeHandler);
		window.addEventListener("onload", windowResizeHandler);
		window.addEventListener('scroll', updateFunc);

		// If content height changes, update so animation still works 
		onElementHeightChange(document.body, updateFunc);

		windowResizeHandler(); // Get sizes for main nav and ref element on mount

		return () => {
			window.removeEventListener("resize", windowResizeHandler);
			window.removeEventListener('scroll', updateFunc);
		}
	}, []);

	useEffect(() => {
		return () => clearTimeout(retryTimeout);
	}, [retryTimeout]);

	return (
		<div ref={subNavWrapper} className="navBuilderHolder" data-target=".productBuilderHolder">
			<div ref={subNav} className={`navBuilder ${stateValuesRef.current.scroll > stateValuesRef.current.top ? 'nav-pinned' : ''}`}>
				{nav.map(n => {
					if (n.title !== null) {
						return (
							<div className="navBuilderItem" key={n.id}>
								<a title={n.title} href={"#" + n.title.toLowerCase().replace(/ /g, '_')} onClick={(e) => { handleAnchorClick(e, n.title.toLowerCase().replace(/ /g, '_')) }} className="easeScroll">{n.title}</a>
							</div>
						)
					}
				})}
			</div>
		</div>
	);
};

export default SubHeader;
